import React from "react";
import Icon from "./Icon";

export const WhiteLightningIcon = () => (
  <Icon>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7 3.00342V12.0034C7 12.5534 7.45 13.0034 8 13.0034H10V20.1534C10 20.6634 10.67 20.8434 10.93 20.4034L16.12 11.5034C16.51 10.8334 16.03 10.0034 15.26 10.0034H13L15.49 3.35342C15.74 2.70342 15.26 2.00342 14.56 2.00342H8C7.45 2.00342 7 2.45342 7 3.00342Z" fill="#fff"/>
  </Icon>
);
